import * as React from "react"

function SvgComponent(props: React.SVGProps<SVGSVGElement> & { color?: string }) {
  const { height = 24, width = 24, color = "#919EAB" } = props
  return (
    <svg
      height={height}
      width={width}
      {...props}
      fill="none"
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.00003 4C6.00003 4 10 6.94593 10 8C10 9.05413 6 12 6 12"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.25"
      />
    </svg>
  )
}

export default SvgComponent
